// extracted by mini-css-extract-plugin
export default {"title":"Blockinfo_title__9ikBP","text":"Blockinfo_text__iC6G1","list":"Blockinfo_list__Kr0oN","item":"Blockinfo_item__xInqE"};